import SignIn from './signin';
import SignUp from './signup'
import Recovery from './recovery';

export default {
    SignIn,
    SignUp,
    Recovery
}